import { GetOnePeriodicCheckInDto, GetOnePeriodicCheckOutDto } from '../../../types/periodic-check.dto'

export const GET_ONE_PERIODIC_CHECK = 'GET_ONE_PERIODIC_CHECK'
export const GET_ONE_PERIODIC_CHECK_SUCCESS = 'GET_ONE_PERIODIC_CHECK_SUCCESS'
export const GET_ONE_PERIODIC_CHECK_ERROR = 'GET_ONE_PERIODIC_CHECK_ERROR'
export const RESET_GET_ONE_PERIODIC_CHECK = 'RESET_GET_ONE_PERIODIC_CHECK'

export interface GetOnePeriodicCheck {
  type: typeof GET_ONE_PERIODIC_CHECK
  payload: GetOnePeriodicCheckOutDto<any>
}

export interface GetOnePeriodicCheckSuccess {
  type: typeof GET_ONE_PERIODIC_CHECK_SUCCESS
  payload: GetOnePeriodicCheckInDto<any>
}

export interface GetOnePeriodicCheckError {
  type: typeof GET_ONE_PERIODIC_CHECK_ERROR
  payload: string | boolean
}

export interface ResetGetOnePeriodicCheck {
  type: typeof RESET_GET_ONE_PERIODIC_CHECK
  payload: null
}

export interface State {
  data: GetOnePeriodicCheckInDto<any> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOnePeriodicCheck | GetOnePeriodicCheckSuccess | GetOnePeriodicCheckError | ResetGetOnePeriodicCheck
